import { useEffect } from 'react';
import { Stat } from '@yy/yy-stat';

export const stat = new Stat({
  prodid: 'yylive',
  param: {
    sys: '4',
    report_type: 0
  }
});

// https://data.hiido.com/index.php?r=sdkdemand/eventview&id=20040531
export default function useHiidoPV(act_type: string) {
  useEffect(() => {
    stat.emit({
      eventid: 20042757,
      act_type: act_type
    });
  }, []);

  return stat;
}
